import type { TooltipProps } from "recharts";
import React from "react";

import { utcFormat } from "d3-time-format";

type Props = TooltipProps<number, string>;

const formatLabel = utcFormat("%B %d, %Y");

const LABELS = [
  { key: "apy", label: "APY" },
  { key: "apy_base", label: "Base APY" },
  { key: "tvl", label: "TVL" },
  { key: "pps_usd", label: "PPS" },
  { key: "timestamp", label: "Date" },
];

const CustomTooltip = ({ payload, label }: Props) => {
  return (
    <div className="recharts-default-tooltip min-w-[200px] whitespace-nowrap border-0 bg-neutral p-[16px] shadow outline-0">
      <h3 className="recharts-tooltip-label font-mono font-bold uppercase">{label && formatLabel(label)}</h3>
      <ul className="recharts-tooltip-item-list flex flex-col gap-[4px]">
        {(payload || []).map(({ name = "", payload: item, color }) => {
          const { label } = item[name];
          const displayLabel = LABELS.find(oneLabel => oneLabel.key === name)?.label ?? name;

          return (
            <li key={name} className="recharts-tooltip-item flex h-[20px] items-stretch justify-between" style={{ color }}>
              <div className="recharts-tooltip-item-name flex gap-px text-neutral">
                <div className="flex w-[20px] items-center justify-center uppercase" style={{ background: color }}>
                  {displayLabel[0]}
                </div>
                <div className="flex items-center justify-center px-[6px] text-xs uppercase" style={{ background: color }}>
                  {displayLabel}
                </div>
              </div>
              <div className="recharts-tooltip-item-value font-mono">{label ?? "N/A"}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CustomTooltip;
